import DataBase.DBQuery
import Network.HashIsraelTaxConfirmationHelper
import Network.NetworkOutput
import Network.Tasks
import Structs.Respone
import com.example.nihulkavapp.Backend.Network.JsCoroutinesAsyncTask

@JsName("ApiCallWrapper")
class ApiCallWrapper(
    val taskName: String,
    var callback: (result: Any?) -> Unit
) :
    JsCoroutinesAsyncTask<Any?>() {

    val params: HashMap<String, Any> = HashMap()
    var descriptionData = listOf("מוריד", "מקשר מסמכים", "מחשב")

    private var errorText: String? = null

    /**
     * The throwable [doInBackground] swallowed, if any.
     *
     * A failed task resolves to `null`, which tells the caller nothing about the
     * cause — the text only reached the console. Callers that show the user an
     * error read it from here.
     */
    @JsName("lastError")
    fun lastError(): String? = errorText

    @JsName("putParam")
    fun putParam(name: String, value: Any): ApiCallWrapper {
        params[name] = value
        return this
    }
    @JsName("replaceCallback")
    fun replaceCallback(callback: (result: Any?) -> Unit): ApiCallWrapper {
        this.callback = callback
        return this
    }


    init {

    }

    override fun onPreExecute() {
        console.log("on pre")
        super.onPreExecute()
    }


    override suspend fun doInBackground(): Any? {
        errorText = null
        try {
//            var a: List<Agent>
//            a = SharedApi().getAgents()
            var result: Any?
            val taskId = Tasks.valueOf(taskName)
            console.log(taskId.name)
            HashIsraelTaxConfirmationHelper.ensureBeforeTask(taskId, params)
            result = taskId.applyTask(params)
            if (result is Respone<*, *>) {
                val msg = (result as Respone<*, *>).second
                val conflict = (msg is NetworkOutput && msg == NetworkOutput.VERSION_CONFLICT) ||
                    (msg is DBQuery && msg == DBQuery.VERSION_CONFLICT)
                if (conflict) {
                    errorText = "VERSION_CONFLICT"
                    return result
                }
                if (msg is NetworkOutput)
                    if (msg != NetworkOutput.SUCCESS && msg != NetworkOutput.ERROR_EMPTY_QUERY) {
                        return null
                    }
            } else if (result is NetworkOutput) {
                if (result != NetworkOutput.SUCCESS && result != NetworkOutput.ERROR_EMPTY_QUERY) {
                    if (result == NetworkOutput.VERSION_CONFLICT) {
                        errorText = "VERSION_CONFLICT"
                        return result
                    }
                    return null
                }
            }
            return result

        } catch (e: Throwable) {
            // Throwable rather than Exception: a raw JS error is not a Kotlin
            // Exception, so it used to pass straight through this block.
            errorText = e.toString()
            console.error("task " + taskName + " failed: " + e.toString())
            console.error(e.stackTraceToString())
        }
        return null
    }


    override fun onPostExecute(result: Any?) {
        super.onPostExecute(result)
        console.log("on post")
        callback(result)

    }

}